import { sanitize } from 'dompurify'
import * as React from 'react'

export const decodeHtml = (html: string) =>
  React.createElement('div', {
    dangerouslySetInnerHTML: { __html: sanitize(html) },
  })

export const decodeHtmlWithNewTab = (html: string) => {
  const content = new DOMParser().parseFromString(html, 'text/html')

  content.querySelectorAll('a').forEach(a => {
    a.setAttribute('target', '_blank')
  })

  return React.createElement('div', {
    dangerouslySetInnerHTML: {
      __html: sanitize(content.body.innerHTML, { ADD_ATTR: ['target'] }),
    },
  })
}



// WEBPACK FOOTER //
// ./src/utils/decode.ts